<template>
	<div class="price-detail-page">
		<!-- 顶部导航 -->
		<el-page-header @back="$router.back()" content="报价详情管理" class="page-header" />

		<!-- 基础信息 -->
		<el-card class="box-card" shadow="hover">
			<template #header>
				<div class="card-header">
					<span>基础信息</span>
				</div>
			</template>
			<el-form :model="PriceBasic" label-width="100px" inline>
				<el-form-item label="价格表名称">
					<el-input v-model="PriceBasic.PriceListName" placeholder="请输入价格表名称" style="width: 250px;" />
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="PriceBasic.Remark" placeholder="请输入备注" style="width: 300px;" />
				</el-form-item>
			</el-form>
		</el-card>

		<!-- 价格分组列表 -->
		<div class="groups-container">
			<el-card 
				v-for="(group, gIndex) in PriceListData" 
				:key="gIndex" 
				class="group-card" 
				shadow="always"
			>
				<template #header>
					<div class="group-header">
						<div class="header-left">
							<el-input 
								v-model="group.PriceGroupName" 
								placeholder="分区名称" 
								style="width: 120px; margin-right: 10px;" 
								size="small"
							/>
							<div class="area-tags">
								<el-tag 
									v-if="group.AreaList.length === 0" 
									type="info" 
									effect="plain" 
									size="small"
								>
									未选择目的地
								</el-tag>
								<el-tag 
									v-else 
									closable 
									:disable-transitions="false"
									@close="removeArea(gIndex, aIndex)"
									v-for="(area, aIndex) in group.AreaList" 
									:key="area.area_code"
									size="small"
									class="area-tag"
								>
									{{ area.area_name }}
								</el-tag>
								<el-button link type="primary" size="small" @click="openAreaSelector(gIndex)">
									+ 添加目的地
								</el-button>
							</div>
						</div>
						<div class="header-right">
							<el-button 
								link 
								type="danger" 
								size="small" 
								@click="removeGroup(gIndex)"
								v-if="PriceListData.length > 1"
							>
								删除此分区
							</el-button>
						</div>
					</div>
				</template>

				<!-- 重量段与价格表格 -->
				<el-table :data="group.PriceDetails" border style="width: 100%" size="small">
					<el-table-column label="重量范围 (KG)" width="200" align="center">
						<template #default="scope">
							<div class="weight-range">
								<el-input-number 
									v-model="scope.row.MinWeight" 
									:precision="2" 
									:step="0.1" 
									:min="0" 
									:controls="false"
									style="width: 45%"
								/>
								<span class="separator">-</span>
								<el-input-number 
									v-model="scope.row.MaxWeight" 
									:precision="2" 
									:step="0.1" 
									:min="scope.row.MinWeight + 0.01" 
									:controls="false"
									style="width: 45%"
								/>
							</div>
						</template>
					</el-table-column>

					<el-table-column label="计费方式" width="150" align="center">
						<template #default="scope">
							<el-select v-model="scope.row.calculation.ChargeModel" placeholder="选择" size="small">
								<el-option 
									v-for="item in calculationType" 
									:key="item.code" 
									:label="item.name" 
									:value="item.code" 
								/>
							</el-select>
						</template>
					</el-table-column>

					<el-table-column label="价格设置" min-width="300">
						<template #default="scope">
							<!-- 固定价格 -->
							<div v-if="scope.row.calculation.ChargeModel === 'Fixed'" class="price-inputs">
								<el-input v-model="scope.row.calculation.FixedPrice.Price" placeholder="一口价">
									<template #append>元</template>
								</el-input>
							</div>

							<!-- 简单重量 -->
							<div v-else-if="scope.row.calculation.ChargeModel === 'SimpleWeight'" class="price-inputs">
								<el-input v-model="scope.row.calculation.SimpleWeight.Price" placeholder="单价">
									<template #append>元/KG</template>
								</el-input>
							</div>

							<!-- 首续重 -->
							<div v-else-if="scope.row.calculation.ChargeModel === 'FirstContinuing'" class="first-continuing">
								<el-row :gutter="10">
									<el-col :span="12">
										<el-input v-model="scope.row.calculation.FirstContinuing.FirstWeight" placeholder="首重">
											<template #prepend>首重(KG)</template>
										</el-input>
									</el-col>
									<el-col :span="12">
										<el-input v-model="scope.row.calculation.FirstContinuing.FirstPrice" placeholder="首重费">
											<template #prepend>费用(元)</template>
										</el-input>
									</el-col>
									<el-col :span="12" style="margin-top: 5px;">
										<el-input v-model="scope.row.calculation.FirstContinuing.ContinuedWeight" placeholder="续重">
											<template #prepend>续重(KG)</template>
										</el-input>
									</el-col>
									<el-col :span="12" style="margin-top: 5px;">
										<el-input v-model="scope.row.calculation.FirstContinuing.ContinuedPrice" placeholder="续重费">
											<template #prepend>费用(元)</template>
										</el-input>
									</el-col>
								</el-row>
							</div>
							
							<div v-else class="price-inputs">
								<span class="text-muted">请选择计费方式以设置价格</span>
							</div>
						</template>
					</el-table-column>

					<el-table-column label="操作" width="80" align="center" fixed="right">
						<template #default="scope">
							<el-button 
								link 
								type="danger" 
								size="small" 
								@click="removeWeightRange(gIndex, scope.$index)"
								v-if="group.PriceDetails.length > 1"
							>
								删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>

				<div class="add-weight-btn">
					<el-button link type="primary" @click="addWeightRange(gIndex)">
						<el-icon><Plus /></el-icon> 添加重量段
					</el-button>
				</div>
			</el-card>

			<div class="add-group-btn-container">
				<el-button type="primary" plain @click="addGroup">
					<el-icon><Plus /></el-icon> 新增价格分区
				</el-button>
			</div>
		</div>

		<!-- 底部操作栏 -->
		<div class="footer-actions">
			<el-button @click="$router.back()">取消</el-button>
			<el-button type="primary" @click="submitPriceList" :loading="submitting">保存价格表</el-button>
		</div>

		<!-- 目的地选择弹窗 -->
		<el-dialog v-model="areaDialogVisible" title="选择目的地" width="600px">
			<div class="area-selector">
				<div v-for="zone in objectiveAreaList" :key="zone.area_code" class="zone-block">
					<div class="zone-title">{{ zone.area_name }}</div>
					<div class="province-list">
						<div 
							v-for="prov in zone.children" 
							:key="prov.area_code"
							class="province-item"
							:class="{ 
								'selected': isAreaSelectedInCurrentGroup(prov),
								'disabled': isAreaUsedByOtherGroups(prov) && !isAreaSelectedInCurrentGroup(prov)
							}"
							@click="toggleAreaSelection(prov)"
						>
							{{ prov.area_name }}
						</div>
					</div>
				</div>
			</div>
			<template #footer>
				<el-button @click="areaDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="confirmAreaSelection">确定</el-button>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	import { Plus } from '@element-plus/icons-vue';

	export default {
		components: { Plus },
		data() {
			return {
				submitting: false,
				PriceBasic: {
					PriceListName: "",
					Remark: ""
				},
				PriceListData: [],
				calculationType: [
					{ name: '固定价格', code: 'Fixed' },
					{ name: '简单重量', code: 'SimpleWeight' },
					{ name: '首/续重', code: 'FirstContinuing' },
					{ name: '步进价格', code: 'Stepping' }
				],
				objectiveAreaList: [
					{
						area_code: 1, area_name: '华东地区',
						children: [
							{ area_name: '上海', area_code: '310000' },
							{ area_name: '浙江', area_code: '330000' },
							{ area_name: '江苏', area_code: '320000' },
							{ area_name: '安徽', area_code: '340000' },
							{ area_name: '江西', area_code: '360000' },
							{ area_name: '福建', area_code: '350000' },
							{ area_name: '山东', area_code: '370000' }
						]
					},
					{
						area_code: 2, area_name: '华南地区',
						children: [
							{ area_name: '广东', area_code: '440000' },
							{ area_name: '广西', area_code: '450000' },
							{ area_name: '海南', area_code: '460000' }
						]
					},
					{
						area_code: 3, area_name: '华北地区',
						children: [
							{ area_name: '北京', area_code: '110000' },
							{ area_name: '天津', area_code: '120000' },
							{ area_name: '河北', area_code: '130000' },
							{ area_name: '山西', area_code: '140000' },
							{ area_name: '内蒙古', area_code: '150000' }
						]
					},
					{
						area_code: 4, area_name: '华中地区',
						children: [
							{ area_name: '河南', area_code: '410000' },
							{ area_name: '湖北', area_code: '420000' },
							{ area_name: '湖南', area_code: '430000' }
						]
					},
					{
						area_code: 5, area_name: '西南地区',
						children: [
							{ area_name: '四川', area_code: '510000' },
							{ area_name: '贵州', area_code: '520000' },
							{ area_name: '云南', area_code: '530000' },
							{ area_name: '重庆', area_code: '500000' },
							{ area_name: '西藏', area_code: '540000' }
						]
					},
					{
						area_code: 6, area_name: '西北地区',
						children: [
							{ area_name: '陕西', area_code: '610000' },
							{ area_name: '甘肃', area_code: '620000' },
							{ area_name: '青海', area_code: '630000' },
							{ area_name: '宁夏', area_code: '640000' },
							{ area_name: '新疆', area_code: '650000' }
						]
					},
					{
						area_code: 7, area_name: '东北地区',
						children: [
							{ area_name: '黑龙江', area_code: '230000' },
							{ area_name: '吉林', area_code: '220000' },
							{ area_name: '辽宁', area_code: '210000' }
						]
					},
					{
						area_code: 8, area_name: '海外地区',
						children: [
							{ area_name: '香港', area_code: '810000' },
							{ area_name: '澳门', area_code: '820000' },
							{ area_name: '台湾', area_code: '710000' }
						]
					}
				],
				areaDialogVisible: false,
				currentEditingGroupIndex: null,
				tempSelectedAreas: [] // 临时存储弹窗中选中的区域
			}
		},
		methods: {
			// 初始化默认数据
			initDefaultData() {
				if (this.PriceListData.length === 0) {
					this.addGroup();
				}
			},

			// 新增分区
			addGroup() {
				const newIndex = this.PriceListData.length;
				const prevGroup = this.PriceListData[newIndex - 1];
				
				// 克隆上一个分区的重量段结构，但清空价格
				let newPriceDetails = [{
					MinWeight: 0.01,
					MaxWeight: 1.00,
					calculation: this.getEmptyCalculation('Fixed')
				}];

				if (prevGroup && prevGroup.PriceDetails) {
					newPriceDetails = prevGroup.PriceDetails.map(item => ({
						MinWeight: item.MinWeight,
						MaxWeight: item.MaxWeight,
						calculation: this.getEmptyCalculation(item.calculation.ChargeModel)
					}));
				}

				this.PriceListData.push({
					PriceGroupName: `分区 ${newIndex + 1}`,
					AreaList: [],
					PriceDetails: newPriceDetails
				});
			},

			// 获取空的计算模型
			getEmptyCalculation(type) {
				return {
					ChargeModel: type || 'Fixed',
					FixedPrice: { Price: 0 },
					SimpleWeight: { Price: 0, Weight: 1 },
					FirstContinuing: { FirstWeight: 1, FirstPrice: 0, ContinuedWeight: 1, ContinuedPrice: 0 }
				};
			},

			// 删除分区
			removeGroup(index) {
				this.PriceListData.splice(index, 1);
			},

			// 添加重量段
			addWeightRange(gIndex) {
				const group = this.PriceListData[gIndex];
				const lastDetail = group.PriceDetails[group.PriceDetails.length - 1];
				
				const newMin = lastDetail ? lastDetail.MaxWeight + 0.01 : 1.01;
				
				group.PriceDetails.push({
					MinWeight: parseFloat(newMin.toFixed(2)),
					MaxWeight: parseFloat((newMin + 1).toFixed(2)),
					calculation: this.getEmptyCalculation(lastDetail ? lastDetail.calculation.ChargeModel : 'Fixed')
				});
			},

			// 删除重量段
			removeWeightRange(gIndex, dIndex) {
				this.PriceListData[gIndex].PriceDetails.splice(dIndex, 1);
			},

			// 打开区域选择器
			openAreaSelector(gIndex) {
				this.currentEditingGroupIndex = gIndex;
				// 复制当前已选区域到临时变量，用于弹窗内的多选操作
				this.tempSelectedAreas = [...this.PriceListData[gIndex].AreaList];
				this.areaDialogVisible = true;
			},

			// 判断当前组是否已选
			isAreaSelectedInCurrentGroup(area) {
				return this.tempSelectedAreas.some(a => a.area_code === area.area_code);
			},

			// 判断其他组是否已用（互斥逻辑）
			isAreaUsedByOtherGroups(area) {
				return this.PriceListData.some((group, index) => {
					if (index === this.currentEditingGroupIndex) return false;
					return group.AreaList.some(a => a.area_code === area.area_code);
				});
			},

			// 切换选择
			toggleAreaSelection(area) {
				if (this.isAreaUsedByOtherGroups(area) && !this.isAreaSelectedInCurrentGroup(area)) {
					this.$message.warning(`该目的地已在其他分区中使用`);
					return;
				}

				const index = this.tempSelectedAreas.findIndex(a => a.area_code === area.area_code);
				if (index > -1) {
					this.tempSelectedAreas.splice(index, 1);
				} else {
					this.tempSelectedAreas.push(area);
				}
			},

			// 确认选择
			confirmAreaSelection() {
				if (this.currentEditingGroupIndex !== null) {
					this.PriceListData[this.currentEditingGroupIndex].AreaList = this.tempSelectedAreas;
				}
				this.areaDialogVisible = false;
			},

			// 移除标签
			removeArea(gIndex, aIndex) {
				this.PriceListData[gIndex].AreaList.splice(aIndex, 1);
			},

			// 提交
			submitPriceList() {
				if (!this.PriceBasic.PriceListName) {
					this.$message.warning('请输入价格表名称');
					return;
				}
				
				// 简单校验
				for (let i = 0; i < this.PriceListData.length; i++) {
					const group = this.PriceListData[i];
					if (group.AreaList.length === 0) {
						this.$message.warning(`请为 "${group.PriceGroupName}" 选择目的地`);
						return;
					}
					if (group.PriceDetails.some(d => !d.calculation.ChargeModel)) {
						this.$message.warning(`请完善 "${group.PriceGroupName}" 的计费方式`);
						return;
					}
				}

				this.submitting = true;
				const form = {
					PriceBasic: this.PriceBasic,
					PriceListData: this.PriceListData
				};

				this.apiService.post({
					modules: "newCreatePriceList",
					content: form
				})
				.then((res) => {
					if (res.status) {
						this.$message.success('保存成功');
						setTimeout(() => {
							this.$router.back();
						}, 1000);
					} else {
						this.$message.error(res.msg || '保存失败');
					}
				})
				.catch(err => {
					console.error(err);
					this.$message.error('网络异常');
				})
				.finally(() => {
					this.submitting = false;
				});
			},

			// 获取详情
			getPriceDetails(priceListId) {
				if (!priceListId) return;
				
				this.apiService.post({
					modules: "newPriceDetails",
					content: { priceListId }
				})
				.then((res) => {
					if (res.status) {
						this.PriceBasic = res.data.PriceBasic || {};
						this.PriceListData = res.data.PriceListData || [];
					}
				});
			}
		},
		created() {
			const priceListId = this.$route.query.priceListId;
			if (priceListId) {
				this.getPriceDetails(priceListId);
			} else {
				this.initDefaultData();
			}
		}
	}
</script>

<style scoped lang="scss">
	.price-detail-page {
		padding: 20px;
		background-color: #f5f7fa;
		min-height: 100vh;
	}

	.page-header {
		margin-bottom: 20px;
		background: #fff;
		padding: 10px 20px;
		border-radius: 4px;
	}

	.box-card {
		margin-bottom: 20px;
	}

	.groups-container {
		margin-bottom: 80px; /* 为底部固定栏留空间 */
	}

	.group-card {
		margin-bottom: 20px;
		
		.group-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			
			.header-left {
				display: flex;
				align-items: center;
				
				.area-tags {
					display: flex;
					flex-wrap: wrap;
					align-items: center;
					gap: 5px;
					
					.area-tag {
						margin-right: 0;
					}
				}
			}
		}
	}

	.weight-range {
		display: flex;
		align-items: center;
		justify-content: center;
		
		.separator {
			margin: 0 5px;
			color: #909399;
		}
	}

	.price-inputs {
		display: flex;
		gap: 10px;
	}
	
	.first-continuing {
		width: 100%;
	}

	.text-muted {
		color: #909399;
		font-size: 12px;
	}

	.add-weight-btn {
		margin-top: 10px;
		text-align: center;
	}

	.add-group-btn-container {
		text-align: center;
		margin-top: 20px;
	}

	.footer-actions {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		background: #fff;
		padding: 15px 40px;
		box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
		text-align: center;
		z-index: 100;
	}

	// 区域选择器样式
	.area-selector {
		max-height: 500px;
		overflow-y: auto;
		
		.zone-block {
			margin-bottom: 20px;
			
			.zone-title {
				font-weight: bold;
				margin-bottom: 10px;
				color: #303133;
				border-bottom: 1px solid #ebeef5;
				padding-bottom: 5px;
			}
			
			.province-list {
				display: flex;
				flex-wrap: wrap;
				gap: 10px;
				
				.province-item {
					padding: 5px 15px;
					border: 1px solid #dcdfe6;
					border-radius: 4px;
					cursor: pointer;
					transition: all 0.3s;
					font-size: 13px;
					
					&:hover {
						border-color: #409eff;
						color: #409eff;
					}
					
					&.selected {
						background-color: #409eff;
						color: #fff;
						border-color: #409eff;
					}
					
					&.disabled {
						background-color: #f5f7fa;
						color: #c0c4cc;
						border-color: #e4e7ed;
						cursor: not-allowed;
						
						&:hover {
							border-color: #e4e7ed;
							color: #c0c4cc;
						}
					}
				}
			}
		}
	}
</style>